/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { globalAccountsView, postData } from '../../redux/reducers/data';
import { setMessage } from '../../redux/actions/message';
import AccountLabel from '../../elements/AccountLabel';
import SublistOkCancel from './SublistOkCancel';

// also handles pension payout and loan interest
export default function BlueTransactionsInterestRent({ selectedOption, accountId, linkedAttribute, handleCloseAfterSale, handleCancel, transactions }) {
  // for INTEREST or RENT, show a list of all accounts which are connected to current deposit account
  const { t } = useTranslation('accountDetails', { keyPrefix: 'deposits' });
  const [loading, setLoading] = useState(false);
  const [localLinkedAttribute, setLocalLinkedAttribute] = useState(linkedAttribute);
  // ↑ intialise to the object from props (should there be an existing linkedAttribute already) { linkedTransaction, accountId, assetId }
  const dispatch = useDispatch();
  const allAccounts = useSelector(globalAccountsView) || [];

  let accountsFilteredByConnectedAccounts = [];
  // for interest show all deposit accounts
  if (selectedOption.id === 'investment-interest' || selectedOption.id === 'investment-loanInterest') {
    accountsFilteredByConnectedAccounts = allAccounts.filter((a) => a.category === 'deposits');
  }

  // for rent show connected real estate accounts only
  if (selectedOption.id === 'investment-rent') {
    accountsFilteredByConnectedAccounts = allAccounts.filter((a) => a.connectedDepositAccounts?.includes(accountId) && a.category === 'realEstate');
  }

  // for rent show connected real estate accounts only
  if (selectedOption.id === 'investment-pension') {
    accountsFilteredByConnectedAccounts = allAccounts.filter((a) => a.connectedDepositAccounts?.includes(accountId) && a.category === 'pension');
  }

  async function handleSave() {
    if (transactions.length === 0) return;

    if (!localLinkedAttribute?.accountId) {
      dispatch(setMessage('symbolNotSelected'));
      return;
    }

    const updatedTransactions = transactions.map((transaction) => {
      const tags = typeof transaction.tags === 'string' ? JSON.parse(transaction.tags) : transaction.tags;
      return {
        ...transaction,
        label: selectedOption.id,
        importFlag: 'put',
        tags: {
          ...tags,
          assetId: localLinkedAttribute.assetId,
          accountId: localLinkedAttribute.accountId,
        },
      };
    });

    setLoading(true);
    try {
      await dispatch(
        postData({
          data: updatedTransactions,
          category: 'deposits',
          accountId,
        }),
      );
    } catch (err) {
      setLoading(false);
      dispatch(setMessage('dataUpdateError'));
      return;
    }

    setLoading(false);
    handleCloseAfterSale();
  }

  const accountsOptionSpecific = (accountsFilteredByConnectedAccounts || []).filter((x) => {
    switch (selectedOption.id) {
      case 'investment-interest':
        return x.category === 'deposits';
      case 'investment-rent':
        return x.category === 'realEstate';
      case 'investment-loanInterest':
        return x.category === 'loans';
      case 'investment-pension':
        return x.category === 'pension';
      default:
        return false;
    }
  });

  if (transactions.length === 0) return null;

  return (
    <>
      <div className="flex flex-col gap-2 overflow-y-auto" data-testid="blue-transactions-interest-rent">
        {accountsOptionSpecific.map((x) => (
          // ^^ returns an array of account objects
          <button
            type="button"
            key={x.id}
            onClick={() => setLocalLinkedAttribute({
              ...localLinkedAttribute,
              accountId: x.id,
              assetId: x.id,
            })}
            data-testid="sublist-account"
            className={`text-xs border border-gray-200 shadow-sm rounded-md p-2 flex justify-between gap-2 cursor-pointer
          ${x?.id === localLinkedAttribute?.accountId ? 'bg-brandBlue-500 text-white hover:bg-brandBlue-600 border-transparent' : 'bg-white text-gray-900 hover:bg-gray-50'}`}
          >
            <AccountLabel accountName={x?.name} category={x?.category} />
          </button>
        ))}
        {accountsOptionSpecific.length === 0 && <div className="text-sm text-gray-500 self-center mt-2">{t('noAccounts')}</div>}
      </div>
      <div className="space-y-2">
        <SublistOkCancel handleSave={handleSave} handleCancel={handleCancel} loading={loading} />
      </div>
    </>
  );
}
BlueTransactionsInterestRent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  selectedOption: PropTypes.objectOf(PropTypes.any).isRequired,
  accountId: PropTypes.string.isRequired,
  linkedAttribute: PropTypes.object,
  handleCancel: PropTypes.func.isRequired,
  handleCloseAfterSale: PropTypes.func.isRequired,
  transactions: PropTypes.arrayOf(PropTypes.object).isRequired,
};
BlueTransactionsInterestRent.defaultProps = {
  linkedAttribute: {},
};
